"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { inputs } from "./inputs.builder";

export const NotFoundComponent: RegisteredComponent = {
  name: "NotFound",
  component: dynamic(async () => (await import("./NotFound")).NotFound),
  inputs,
};
